export default __webpack_public_path__ + "static/media/Connor.01f1bbba.png";